import React from 'react';
import {cls } from '../../../packages/components';
import Asset from '../../../requests/apa/Asset';
import ProgressBar from '../../ProgressBar';
import Utils from '../../../utils/Utils';
import Translator from '../../../requests/apa/Translator';

const CardEpisode = ({episode, width, isFakeCard = false, percent = null, pbi = null, onClick = null}) => {
    const getAssetPlay = ()=>{
        return Asset.get('seasons_ribbon_option_button_play', '/images/ic_play.png')
    }

    const getTitleTruncate = (title) => {
        return Utils.cutPlayerString(title, 35, 30);
    }

    const resizeImage = (url) => {
        let urlNew = '';
        urlNew = `url('${url}?size&imwidth=254')`;

        return urlNew;
    }

    function withEllipsis(text, maxLength) {
        if(text.length > maxLength) {
            return text.slice(0, maxLength - 3).concat("...");
        }
        return text
    }

    const getPurchaseText = (pbi) => {
        let text = '';
        if (pbi && pbi.playButton && pbi.playButton.waspurchased === "1") return text;
        
        if (pbi && Array.isArray(pbi.buttons) && pbi.buttons.length !== 0) {
            const purchasableButtons = pbi.buttons.filter(btn => btn.waspurchased === '0'); //&& btn.price !== '0');
            const prices = purchasableButtons.map(btn => parseFloat(btn.price.replace(',', '.')));
            const minPrice = prices.length !== 0 ? Math.min(...prices) : null;
            if (minPrice) {
                const button = purchasableButtons.find(btn => btn.price.replace(',', '.') === minPrice.toString());
                const {currency, price} = button;
                text = withEllipsis(Translator.get('playing_ribbon_offerEpisode_label'), 25);
                text += ' ' + currency + price;
            }
        }
        return text;
    }

    return (
        episode && <div
            style={{ width: width}}
            className={cls(`aaf-main-modal-options-episodes-main-container-main`)}>
            <a
                href="javascript:void(0)"
                className={cls('aaf-main-modal-options-episodes-main-container', (!isFakeCard ? 'focusable': ''))}
                id={`modal_episode_number_${Number.isInteger(episode.idx_temp) ? episode.idx_temp : null}`}
                data-id={Number.isInteger(episode.idx_temp) ? episode.idx_temp : null}
                tabIndex={0}
                onClick = { () =>{
                    onClick && (typeof onClick === 'function') && onClick(episode);
                }}>
                <div className="aaf-main-modal-options-episodes-main-image">
                    <div
                        className={cls('aaf-main-modal-options-episodes-main-image-div')}
                        style={{
                            backgroundImage: resizeImage(episode.image_still),
                            backgroundPosition: `${!isFakeCard ? 'center': 'center left'}`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                        }}>
                        <div className={cls('aaf-main-modal-options-episodes-main-image-div-progress-bar')}>
                            <div className={cls('aaf-main-modal-options-episodes-main-image-div-progress-children')}>
                                <ProgressBar percent ={percent}/>
                            </div>
                        </div>
                        <div className={cls('aaf-main-modal-options-episodes-main-image-div-purchase')}>
                            <p className= {cls('aaf-main-modal-options-episodes-main-image-div-purchase-text')}>{getPurchaseText(pbi)}</p>
                        </div>
                    </div>
                    <div className={cls('aaf-main-modal-options-episodes-main-image-title')}>
                        {!isFakeCard && <span>{getTitleTruncate(`${episode.episode_number}. ${episode.title_episode}`)}</span>}
                    </div>
                </div>
                <div className="aaf-main-modal-options-episodes-main-middle">
                    <img src={getAssetPlay()} className={cls('aaf-main-modal-options-episodes-main-middle-img')} alt={episode.idx_temp} />
                </div>
            </a>
        </div>
    );
};
export default CardEpisode;



// WEBPACK FOOTER //
// ./src/components/EpisodeSelection/components/CardEpisode.jsx